import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const validateDeliveryInformationRequired =
  (): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null =>
    typeof control.value?.deliveryDate !== 'string' ? { deliveryInformationRequired: true } : null;
